import React, { useState, useEffect } from 'react'

import './CropProductionChart.css'
import { store } from '../../../../stores/store'
import IndicatorsPool from '../../../../js/IndicatorsPool'
import { VictoryChart, VictoryGroup, VictoryBar, VictoryLegend } from 'victory'
import MyTooltip from '../MyTooltip/MyTooltip'

function getValues(ids) {
  let value = 0
  ids.forEach(indId => {
    let val = IndicatorsPool.getIndicatorValue(indId)
    value += val
  })
  return value
}

const CropProductionChart = () => {
  let data = [
    {
      name: store.t("wheat"),
      products: getValues(["indF3"]),
      demands: getValues(["indAn149"]),
      unit: IndicatorsPool.getIndicator("indF3").unit
    },
    {
      name: store.t("barley"),
      products: getValues(["indF5"]),
      demands: getValues(["indAn145"]),
      unit: IndicatorsPool.getIndicator("indF5").unit
    },
    {
      name: store.t("rapeseed"),
      products: getValues(["indF9"]),
      demands: getValues(["indAn146"]),
      unit: IndicatorsPool.getIndicator("indF9").unit
    },
    {
      name: store.t("faba_bean"),
      products: getValues(["indF11"]),
      demands: getValues(["indAn148"]),
      unit: IndicatorsPool.getIndicator("indF11").unit
    },
    {
      name: store.t("maize"),
      products: getValues(["indF12"]),
      demands: getValues(["indAn139"]),
      unit: IndicatorsPool.getIndicator("indF12").unit
    },
    {
      name: store.t("alfalfa"),
      products: getValues(["indF13"]),
      demands: getValues(["indAn141"]),
      unit: IndicatorsPool.getIndicator("indF13").unit
    },
    {
      name: store.t("sorghum"),
      products: getValues(["indF14"]),
      demands: getValues(["indAn142"]),
      unit: IndicatorsPool.getIndicator("indF14").unit
    },
    {
      name: store.t("grass"),
      products: getValues(["indF15", "indF16"]),
      demands: getValues(["indAn140", "indAn143", "indAn144"]),
      unit: IndicatorsPool.getIndicator("indF15").unit
    },
    {
      name: store.t("straw"),
      products: getValues(["indF4", "indF6"]),
      demands: getValues(["indAn134"]),
      unit: IndicatorsPool.getIndicator("indF4").unit
    },
    {
      name: store.t("soybean"),
      products: getValues([]),
      demands: getValues(["indAn147"]),
      unit: IndicatorsPool.getIndicator("indAn147").unit
    },
    {
      name: store.t("sugar_beet", "Sugar beet"),
      products: getValues(["indF7"]),
      demands: getValues([]),
      unit: IndicatorsPool.getIndicator("indF7").unit
    },
    {
      name: store.t("potato", "Potato"),
      products: getValues(["indF8"]),
      demands: getValues([]),
      unit: IndicatorsPool.getIndicator("indF8").unit
    },
    {
      name: store.t("pea", "Pea"),
      products: getValues(["indF10"]),
      demands: getValues([]),
      unit: IndicatorsPool.getIndicator("indF10").unit
    }
  ]

  data = data.filter(vals => {
    return vals.products !== 0 || vals.demands !== 0
  })


  let prodData = data.map( ({name, products, unit}) => ({ x: name, y: products, label: "<div style='text-align: center;'>" + Math.round(products) + unit + "</div>"}) )
  let demandsData = data.map( ({name, demands, unit}) => ({ x: name, y: demands, label: "<div style='text-align: center;'>" + Math.round(demands) + unit + "</div>"}) )


  return (
    <div className="CropProductionChart">
      <div className="yaxis-label">
        {store.t("crop_prod_legend_title")}
        <small>{store.t("crop_prod_legend_subtitle")}</small>
      </div>

      <VictoryChart
      width={600}
      height={250}

      animate={{onLoad: { delay: 0, duration: 1 }, duration: 500}}
      domainPadding={{ x: 100, y: 0 }}>

        <VictoryLegend x={75} y={0} gutter={20}
          orientation="horizontal"
          style={{ border: { stroke: "black" }, title: {fontSize: 15 } }}
          data={[
            { name: store.t("products"), symbol: { fill: "#8884d8" , type: "square" } },
            { name: store.t("demands"), symbol: { fill: "#82ca9d" , type: "square" } }
          ]}
        />

        <VictoryGroup offset={15} colorScale={["#8884d8", "#82ca9d"]}>
          <VictoryBar barWidth={15} data={prodData} labelComponent={<MyTooltip />} />
          <VictoryBar barWidth={15} data={demandsData} labelComponent={<MyTooltip />} />
        </VictoryGroup>
      </VictoryChart>
    </div>
  );
};

export default CropProductionChart;
